import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { Link } from "react-router-dom";


export default function Blog() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get('https://dropshopi.com/api/get-blogs.php')
      .then((res) => {
        if (res.data.status === 'success') {
          setBlogs(res.data.data);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch blogs:', err);
      });
  }, []);

  return (
    <div className="bg-black text-white items-center container-fluid">

      {/* strategy */}
      <div className="bg-black text-white py-2 mb-5 mt-5">
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
          <div className="box-container">
            <div className="strategy-card text-center px-4">
              <h1 className="display-3 fw-bold anton ft3 mt-4">
                Ready to Experience Game-Changing Growth?<br />
                Put Our <span className="text-warning2">NEXT LEVEL STRATEGY</span> to the Test
              </h1>
              <p className="text-secondary mt-4 fs-5 fw-medium">
                <span className="text-warning2"><span>&#9889;</span> Limited Spots Available - </span>
                We only work with entrepreneurs who<br />
                are ready to <strong>scale and maximise ROAS</strong>.
                Don’t miss this<br /> opportunity – book your session today!
              </p>
              <Button variant="primary" className="btn-purple mb-4 mt-4">
                Book Your Free Strategic Call <span>&#9889;</span>
              </Button>
            </div>
          </div>
        </Container>
      </div>

      <div className="home" style={{ margin: "100px auto 0 auto" }}>
        <h1 className="display-3 fw-bold anton ft1">
          The latests <br />
          <span className="text-warning2">NEWS and UPDATES</span>
        </h1>
        <p className="mt-4 text-secondary fs-5">
          Get expert insights, practical tips, the latest news and events, so you're always<br />
          up to date.
        </p>
        <div>
          <div className="framer1"></div>
        </div>
      </div>

      {/* Blog */}
     <div className="max-w-3xl mx-auto rounded-3xl bg-gradient-to-tr from-[#2e2eff] via-[#ff00ff] to-[#ff6600] p-[2px] container mb-5">
  <div className="bg-black rounded-3xl overflow-hidden">
    <div className='blog-container'>
      <h2>Blogs</h2>
    </div>

    {blogs.map((blog) => (
      <div className="blog-content" key={blog.id}>
        <h3 className="text-base text-white">
          <Link to={`/blog-detail/${blog.slug}`} className="text-warning2 text-decoration-none">
            {blog.title}
          </Link>
        </h3>
        <p className="text-base text-gray-500">{blog.meta_title || "No Category"}</p>
      </div>
    ))}
  </div>
</div>
    </div>
  );
}
